import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlListaIndicadores = '/service/planejamentoEstrategico/indicadores/'

class ConsultaListaIndicadoresService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio ? filtro.exercicio.value : '',
            planoEstrategico: filtro.planoEstrategico ? filtro.planoEstrategico.map(e => e.value) : null,
            tema: filtro.tema ? filtro.tema.map(e => e.value) : null,
            objetivoEstrategico: filtro.objetivoEstrategico ? filtro.objetivoEstrategico.map(e => e.value) : null,
            unidadeMedida: filtro.unidadeMedida ? filtro.unidadeMedida.map(e => e.value) : null,
        }
        return this.conex.post(urlListaIndicadores + 'listaIndicadores/', JSON.stringify(data))
    }
}

export default ConsultaListaIndicadoresService
